import React from 'react'
import style from './style.css'

export default ({ label, children, type, ...props }) =>
<span className={[style.tag, style[type]].join(' ')}>
    {children}
</span>


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/Tag/index.js